import { Module } from "src/state/Module"
import * as Types from "src/state/gql/_types"

export const AreaModule = new Module<Types.AreaFragment, Types.GetAreasQueryVariables, Types.Areas_Insert_Input>({
    sortKey: 'created_at',
})